module.exports = __webpack_public_path__ + "static/media/inspire19Louisa.419e02f0.jpeg";